import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.App.Head.title',
    defaultMessage: 'Corretor {companyName}',
  },
});
